import { HoursFixed, HoursRange } from '../../types/shared';

export const isHoursRange = (hours?: unknown): hours is HoursRange => {
  return typeof hours === 'object' && !!hours && 'min' in hours && 'max' in hours;
};

export const isHoursFixed = (hours?: unknown): hours is HoursFixed => {
  return typeof hours === 'object' && !!hours && 'value' in hours;
};
